class SidebarService {
    constructor() {
        this.menuItems = [
        //     {
        //     name: 'Search',
        //     link: '/search',
        //     analyticsEvent: 'Search click',
        //     icon: 'icon-ra-search',
        //     pageName: 'search',
        //     displayFlag: 'showSearch',
        // },
        // {
        //     name: 'Dashboard',
        //     link: '/dashboard',
        //     analyticsEvent: 'Dashboard click',
        //     icon: 'icon-ra-dashboard',
        //     pageName: 'dashboard',
        //     displayFlag: 'showDashboard',
        // },
        // {
        //     name: 'Pipeline',
        //     link: '/pipeline/leads',
        //     analyticsEvent: 'Pipeline click',
        //     icon: 'icon-ra-pipeline',
        //     pageName: 'pipeline',
        //     displayFlag: 'showPipeline',
        // },
        // {
        //     name: 'Benji',
        //     link: '',
        //     analyticsEvent: 'Benji Portal click',
        //     icon: 'icon-ra-pipeline',
        //     pageName: 'benji',
        //     isEnabled: false,
        // },
        // {
        //     name: 'Product Lookup',
        //     link: '/product-lookup/directory/CA/',
        //     analyticsEvent: 'Product Lookup click',
        //     icon: 'icon-ra-product-lookup',
        //     pageName: 'product-lookup',
        //     displayFlag: 'showProductLookup'        
        // },
        // {
        //     name: 'Reports',
        //     link: 'sso/leadsummary',
        //     analyticsEvent: 'Reports Portal click',
        //     icon: 'icon-reports-thick',
        //     pageName: 'reports',
        //     isEnabled: true,
        // },
        // {
        //     name: 'Resources',
        //     link: '/resources',
        //     analyticsEvent: 'Resources click',
        //     icon: 'icon-ra-resources',
        //     pageName: 'resources',
        //     displayFlag: 'showResources',
        // },
        // {
        //     name: 'Certification',
        //     link: '/certification',
        //     analyticsEvent: 'Certification click',
        //     icon: 'icon-ra-certificate',
        //     pageName: 'certification',
        //     displayFlag: 'showCertification',
        // },
        {
            name: 'Account',
            link: '/accounts/myprofile/',
            analyticsEvent: 'Account click',
            icon: 'icon-ra-account',
            pageName: 'accounts',
            displayFlag: 'showAccounts',
        },
        ];
    }

    getSidebar() {
        return this.menuItems;
    }
}


export default SidebarService;



// WEBPACK FOOTER //
// ./src/app/common/sidebar/sidebarFactory.js